'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_data_UserKind$GeneralPractice$() {
}
export { $c_Lapp_data_UserKind$GeneralPractice$ as $c_Lapp_data_UserKind$GeneralPractice$ };
$c_Lapp_data_UserKind$GeneralPractice$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_data_UserKind$GeneralPractice$.prototype.constructor = $c_Lapp_data_UserKind$GeneralPractice$;
/** @constructor */
function $h_Lapp_data_UserKind$GeneralPractice$() {
}
export { $h_Lapp_data_UserKind$GeneralPractice$ as $h_Lapp_data_UserKind$GeneralPractice$ };
$h_Lapp_data_UserKind$GeneralPractice$.prototype = $c_Lapp_data_UserKind$GeneralPractice$.prototype;
$c_Lapp_data_UserKind$GeneralPractice$.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_data_UserKind$GeneralPractice$.prototype.hashCode__I = (function() {
  return (-1470349789);
});
$c_Lapp_data_UserKind$GeneralPractice$.prototype.toString__T = (function() {
  return "GeneralPractice";
});
$c_Lapp_data_UserKind$GeneralPractice$.prototype.productArity__I = (function() {
  return 0;
});
$c_Lapp_data_UserKind$GeneralPractice$.prototype.productPrefix__T = (function() {
  return "GeneralPractice";
});
$c_Lapp_data_UserKind$GeneralPractice$.prototype.productElement__I__O = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_UserKind$GeneralPractice$.prototype.productElementName__I__T = (function(n) {
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_data_UserKind$GeneralPractice$.prototype.fromProduct__s_Product__O = (function(p) {
  return this;
});
var $d_Lapp_data_UserKind$GeneralPractice$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_data_UserKind$GeneralPractice$, "app.data.UserKind$GeneralPractice$", ({
  Lapp_data_UserKind$GeneralPractice$: 1,
  Lapp_data_UserKind: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_deriving_Mirror: 1,
  s_deriving_Mirror$Product: 1,
  s_deriving_Mirror$Singleton: 1
}));
export { $d_Lapp_data_UserKind$GeneralPractice$ as $d_Lapp_data_UserKind$GeneralPractice$ };
var $n_Lapp_data_UserKind$GeneralPractice$;
function $m_Lapp_data_UserKind$GeneralPractice$() {
  if ((!$n_Lapp_data_UserKind$GeneralPractice$)) {
    $n_Lapp_data_UserKind$GeneralPractice$ = new $c_Lapp_data_UserKind$GeneralPractice$();
  }
  return $n_Lapp_data_UserKind$GeneralPractice$;
}
export { $m_Lapp_data_UserKind$GeneralPractice$ as $m_Lapp_data_UserKind$GeneralPractice$ };
//# sourceMappingURL=app.data.-User-Kind$-General-Practice$.js.map
